import type { Team } from "@dutyon/apis";
import { Paper, Table, Text } from "@dutyon/ui-kit";

interface CompanyTeamListProps {
  teams?: Team[];
  formatDate: (date: Date | string) => string;
}

export function CompanyTeamList({ teams, formatDate }: CompanyTeamListProps) {
  return (
    <Paper withBorder p="md">
      {!teams || teams.length === 0 ? (
        <Text c="dimmed">등록된 팀이 없습니다.</Text>
      ) : (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>팀 이름</Table.Th>
              <Table.Th>설명</Table.Th>
              <Table.Th>등록일</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {teams.map((team) => (
              <Table.Tr key={team.id}>
                <Table.Td style={{ fontWeight: 500 }}>{team.name}</Table.Td>
                <Table.Td>{team.description || "-"}</Table.Td>
                <Table.Td>{formatDate(team.createdAt)}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
}
